import { render } from "./jumpPage.vue?vue&type=template&id=deefe9f0&scoped=true"
import script from "./jumpPage.vue?vue&type=script&lang=js"
export * from "./jumpPage.vue?vue&type=script&lang=js"

import "./jumpPage.vue?vue&type=style&index=0&id=deefe9f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deefe9f0"]])

export default __exports__